import { Spin } from 'antd'

import styled from 'styled-components'

const SpinWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

export function Spinner(): React.ReactNode {
  return (
    <SpinWrapper>
      <Spin spinning />
    </SpinWrapper>
  )
}
